<template>
  <v-progress-linear indeterminate />
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const router = useRouter();
const store = useStore();

onMounted(() => {
  store.dispatch('identify', {
    async success() {
      await router.replace(store.getters.defaultLandingPage());
    },
    async failure() {
      await router.replace({ path: '/' });
    },
  });
});
</script>
